import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Row, Card } from 'react-bootstrap';

import CertificationItem from './CertificationItem';

import { fetchCertificationsByUserId } from 'api/certifications/certifications';

import { decodeToken, handleApiError } from 'utils';


const Certifications = () => {
    const token = useSelector(state => state.authentication.user?.token);
    
    const [certifications, setCertifications] = useState([]);
    
    useEffect(() => {
		if(token !== null && token !== undefined) {
            let user = decodeToken(token)
            loadCertifiedUserById(user.id);
        }
		// eslint-disable-next-line
    }, [token])
    
    const loadCertifiedUserById = async (user_id) => {
        try {
            const { data } = await fetchCertificationsByUserId(user_id, token);
            if(data?.status === 200)
                setCertifications(data.message);
        } catch (error) {
            handleApiError(error);
        }
    };

	return (
		
        <Card>
            <Card.Header className="bg-light">
                <h5 className="mb-0">Tus certificaciones</h5>
            </Card.Header>
            <Card.Body> 
                <Row className="g-3">
                    {certifications.map((cert, index) => (
                        <CertificationItem key={index} cert={cert} />
                    ))}
                </Row>
            </Card.Body>
        </Card>
	);
};

export default Certifications;
